import React, { useState, useEffect } from 'react';
import { useSalon } from '../context/SalonContext';
import { updateSalonInfos } from '../services/pocketbase';
import { FiSave, FiAlertCircle, FiCheck, FiMessageCircle } from 'react-icons/fi';
import './AdminAnnouncements.css';

const AdminAnnouncements = () => {
    const { salonInfos, refreshData } = useSalon();

    // États locaux
    const [formData, setFormData] = useState({
        popup_active: false,
        popup_title: '',
        popup_content: ''
    });

    const [loading, setLoading] = useState(false);
    const [success, setSuccess] = useState(false);
    const [error, setError] = useState(null);

    // Charger les données au montage
    useEffect(() => {
        if (salonInfos) {
            setFormData({
                popup_active: salonInfos.popup_active || false,
                popup_title: salonInfos.popup_title || '',
                popup_content: salonInfos.popup_content || ''
            });
        }
    }, [salonInfos]);

    const handleChange = (e) => {
        const { name, value, type, checked } = e.target;
        setFormData(prev => ({
            ...prev,
            [name]: type === 'checkbox' ? checked : value
        }));

        // Reset success message on change
        if (success) setSuccess(false);
    };

    const handleSubmit = async (e) => {
        e.preventDefault();
        setLoading(true);
        setError(null);
        setSuccess(false);

        try {
            // Mise à jour de la collection existante
            await updateSalonInfos(salonInfos.id, formData);

            // Refresh du context pour que l'app soit à jour
            await refreshData();

            setSuccess(true);
            setTimeout(() => setSuccess(false), 3000);
        } catch (err) {
            console.error(err);
            setError("Erreur lors de la sauvegarde.");
        } finally {
            setLoading(false);
        }
    };

    return (
        <div className="admin-announcements">
            <div className="admin-header-announcement">
                <div className="header-icon">📢</div>
                <div className="header-text">
                    <h1>Annonces & Popups</h1>
                    <p>Gérez le message d'information important (Popup) qui s'affiche à l'arrivée sur le site.</p>
                </div>
            </div>

            <div className="announcement-editor-card">
                <form onSubmit={handleSubmit}>

                    {/* Switch Active */}
                    <div className="form-section-header">
                        <div className="switch-group">
                            <label className="switch">
                                <input
                                    type="checkbox"
                                    name="popup_active"
                                    checked={formData.popup_active}
                                    onChange={handleChange}
                                />
                                <span className="slider round"></span>
                            </label>
                            <span className="switch-label">
                                {formData.popup_active ? "🟢 Popup ACTIVÉ" : "⚪ Popup DÉSACTIVÉ"}
                            </span>
                        </div>
                        <p className="section-help">
                            Si activé, ce message s'affichera par dessus le site lors de la première visite.
                        </p>
                    </div>

                    <div className="form-group-announce">
                        <label>Titre de l'annonce</label>
                        <input
                            type="text"
                            name="popup_title"
                            value={formData.popup_title}
                            onChange={handleChange}
                            placeholder="Ex: Nouvelle organisation à partir de Septembre !"
                            className="input-title"
                        />
                    </div>

                    <div className="form-group-announce">
                        <label>Contenu du message</label>
                        <textarea
                            name="popup_content"
                            value={formData.popup_content}
                            onChange={handleChange}
                            placeholder="Écrivez votre message ici... (Les sauts de lignes sont conservés)"
                            rows={10}
                            className="input-content"
                        />
                        <div className="textarea-help">
                            <FiMessageCircle /> Vous pouvez utiliser des émojis pour rendre le message plus vivant ! ✨
                        </div>
                    </div>

                    {/* Feedback Messages */}
                    {error && <div className="message-box error"><FiAlertCircle /> {error}</div>}
                    {success && <div className="message-box success"><FiCheck /> Modifications enregistrées avec succès !</div>}

                    <div className="form-actions">
                        <button type="submit" className="btn-save-announce" disabled={loading}>
                            {loading ? "Enregistrement..." : <><FiSave /> Enregistrer les modifications</>}
                        </button>
                    </div>

                </form>
            </div>

            {/* Preview Card */}
            <div className="preview-section">
                <h3>Aperçu du rendu</h3>
                <div className="preview-card-mockup">
                    <div className="mockup-header">
                        <h3>{formData.popup_title || "Titre de l'annonce"}</h3>
                    </div>
                    <div className="mockup-body">
                        {formData.popup_content ? (
                            formData.popup_content.split('\n').map((line, i) => <p key={i}>{line}</p>)
                        ) : (
                            <p className="placeholder-text">Le contenu de votre annonce s'affichera ici...</p>
                        )}
                    </div>
                </div>
            </div>
        </div>
    );
};

export default AdminAnnouncements;
